import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './navbar.css';
import navbarImage from "./img-madera-navbar.png";
import logo1nav from "./NAV-LLOGO-PREV.png";

const Navbar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Función SUPER SIMPLE para descargar la revista
  const downloadRevista = () => {
    // Crear enlace directo al PDF en la carpeta public
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/CATALOGO-ELPINO.pdf`;
    link.download = 'CATALOGO-EL-PINO-REVISTA.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    closeMenu();
  };

  const handleNavigation = (path) => {
    navigate(path);
    closeMenu();
  };

  const handleContact = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.getElementById('contact-section');
      if (contactSection) {
        contactSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
    closeMenu();
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-image-container">
        <img src={navbarImage} alt="Background" className="navbar-image" />
      </div>

      <div className="navbar-content">
        <div className="navbar-logo-container">
          <div className="navbar-logo" onClick={() => handleNavigation('/home')}>
            <img src={logo1nav} alt="Artisan Woodworks" />
            <span className="logo-main-text">EL PINO</span>
          </div>
        </div>

        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <button className="nav-link" onClick={() => handleNavigation('/home')}>
            HOME
          </button>
          <button className="nav-link" onClick={() => handleNavigation('/productos')}>
            PRODUCTOS
          </button>
          <button className="nav-link" onClick={handleContact}>
            CONTACTO
          </button>
          {/* Botón simple y directo */}
          <button className="nav-link magazine-button" onClick={downloadRevista}>
            Descargar REVISTA 📥
          </button>
        </div>

        {isMenuOpen && (
          <div className="mobile-menu-overlay active" onClick={closeMenu}></div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;